module.exports = __webpack_public_path__ + "static/media/you-made-it.f560c61a.png";